import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message, Modal } from 'antd';
import { LeftOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import api from '../api';
import { clearSessionPlainPassword } from '../sessionPlainPassword';

export default function ChangePassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ old_password: '', new_password: '', confirm_password: '' });
  const [visible, setVisible] = useState({ old: false, new: false, confirm: false });

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const toggleVisible = (field) => {
    setVisible((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const doChangePassword = async () => {
    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        old_password: form.old_password,
        new_password: form.new_password,
      });
      message.success('密码修改成功，请使用新密码重新登录');
      localStorage.clear();
      clearSessionPlainPassword();
      navigate('/login');
    } catch (err) {
      message.error(err.message || '修改失败');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!form.old_password) {
      message.warning('请输入原密码');
      return;
    }
    if (!form.new_password || !form.new_password.trim()) {
      message.warning('请输入新密码');
      return;
    }
    if (form.new_password.trim().length < 6) {
      message.warning('新密码至少 6 位');
      return;
    }
    if (form.new_password === form.old_password) {
      message.warning('新密码不能与原密码相同');
      return;
    }
    if (form.new_password !== form.confirm_password) {
      message.warning('两次输入的新密码不一致');
      return;
    }

    Modal.confirm({
      title: '确认修改密码',
      content: '修改成功后当前登录将失效，需使用新密码重新登录。是否确认修改？',
      okText: '确认修改',
      cancelText: '取消',
      onOk: () => doChangePassword(),
    });
  };

  const fields = [
    { key: 'old_password', visKey: 'old', placeholder: '请输入原密码' },
    { key: 'new_password', visKey: 'new', placeholder: '请输入新密码' },
    { key: 'confirm_password', visKey: 'confirm', placeholder: '请再次确认新密码' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', paddingBottom: 70 }}>
      <div style={{
        display: 'flex', alignItems: 'center', padding: '12px 16px',
        background: '#fff', borderBottom: '1px solid #f0f0f0', position: 'sticky', top: 0, zIndex: 10,
      }}>
        <LeftOutlined onClick={() => navigate(-1)} style={{ fontSize: 18, marginRight: 12 }} />
        <span style={{ fontSize: 17, fontWeight: 600 }}>修改密码</span>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: 20, margin: '16px 16px 0' }}>
        {fields.map(({ key, visKey, placeholder }) => (
          <div key={key} style={{ marginBottom: 24 }}>
            <div style={{
              display: 'flex', alignItems: 'center',
              borderBottom: '1px solid #e8e8e8', paddingBottom: 10,
            }}>
              <LockOutlined style={{ fontSize: 18, color: '#999', marginRight: 10 }} />
              <input
                type={visible[visKey] ? 'text' : 'password'}
                placeholder={placeholder}
                value={form[key]}
                onChange={(e) => updateField(key, e.target.value)}
                style={{
                  flex: 1, border: 'none', outline: 'none',
                  fontSize: 15, color: '#333', background: 'transparent',
                }}
              />
              <span
                onClick={() => toggleVisible(visKey)}
                style={{
                  fontSize: 18,
                  color: visible[visKey] ? '#1677ff' : '#999',
                  cursor: 'pointer',
                  padding: '0 4px',
                  lineHeight: 1,
                }}
              >
                {visible[visKey] ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </span>
            </div>
          </div>
        ))}

        <div style={{
          border: '1px dashed #91caff', borderRadius: 8,
          background: '#e6f4ff', padding: 12, marginTop: 4,
        }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#1677ff', marginBottom: 6 }}>说明</div>
          <div style={{ fontSize: 12, color: '#666', lineHeight: '22px' }}>
            <div>· 新密码至少 6 位，且不能与原密码相同</div>
            <div>· 修改成功后须使用新密码重新登录</div>
          </div>
        </div>
      </div>

      <div style={{ padding: '24px 16px' }}>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%', height: 46, borderRadius: 23,
            background: loading ? '#91caff' : '#1677ff',
            color: '#fff', fontSize: 16, fontWeight: 600,
            border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? '提交中…' : '确认修改'}
        </button>
      </div>
    </div>
  );
}
